// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0; /* Remove default margin */
    font-family: 'Courier New'; /* Set a default font for better appearance */
}

.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: black;
    color: white;
    margin: auto;
    margin-top: 30px;
    width: 80%; /* Adjust width as needed */
    max-width: 1600px; /* Ensure it doesn't exceed this width */
    border-radius: 30px;
    padding: 20px; /* Add padding for inner spacing */
}

.contact-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: black;
    color: white;
    margin: auto;
    margin-top: 30px;
    width: 80%; /* Adjust width as needed */
    max-width: 1600px; /* Ensure it doesn't exceed this width */
    border-radius: 30px;
    padding: 20px; /* Add padding for inner spacing */
    min-height:600px;

}

.inner-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-color: rgb(35, 35, 34);
    padding:20px;
    border-radius: 30px;
}

form {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

label {
    margin-bottom: 10px; /* Space between label and input */
    font-size: 24px;
}

input, textarea {
    display: block;
    border-radius: 5%;
    width: 300px; /* Fixed width for inputs */
    margin: 5px 0; /* Space between inputs */
}

.textbox {
    width: 300px; /* Set a consistent width */
}

.input-help {
    width: 100%; /* Full width of the container */
    align-items: center;
    display: flex;
    justify-content: center;
}

textarea {
    width: 100%; /* Make textarea responsive */
    max-width: 300px; /* Restrict maximum width */
}

.submit-button {
    color: white;
    background-color: rgb(0, 157, 255);
    border: none; /* Remove default border */
    font-family:'Courier New', Courier, monospace;
    font-size:21px;
    border-radius: 30%;
    cursor: pointer; /* Change cursor on hover */
    margin-top: 10px; /* Space above the button */
}`, "",{"version":3,"sources":["webpack://./src/components/Contact.css"],"names":[],"mappings":"AAAA;IACI,SAAS,EAAE,0BAA0B;IACrC,0BAA0B,EAAE,6CAA6C;AAC7E;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,UAAU,EAAE,2BAA2B;IACvC,iBAAiB,EAAE,wCAAwC;IAC3D,mBAAmB;IACnB,aAAa,EAAE,kCAAkC;AACrD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,UAAU,EAAE,2BAA2B;IACvC,iBAAiB,EAAE,wCAAwC;IAC3D,mBAAmB;IACnB,aAAa,EAAE,kCAAkC;IACjD,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,iCAAiC;IACjC,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB,EAAE,kCAAkC;IACvD,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,YAAY,EAAE,2BAA2B;IACzC,aAAa,EAAE,yBAAyB;AAC5C;;AAEA;IACI,YAAY,EAAE,2BAA2B;AAC7C;;AAEA;IACI,WAAW,EAAE,gCAAgC;IAC7C,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW,EAAE,6BAA6B;IAC1C,gBAAgB,EAAE,2BAA2B;AACjD;;AAEA;IACI,YAAY;IACZ,kCAAkC;IAClC,YAAY,EAAE,0BAA0B;IACxC,6CAA6C;IAC7C,cAAc;IACd,kBAAkB;IAClB,eAAe,EAAE,2BAA2B;IAC5C,gBAAgB,EAAE,2BAA2B;AACjD","sourcesContent":["body {\n    margin: 0; /* Remove default margin */\n    font-family: 'Courier New'; /* Set a default font for better appearance */\n}\n\n.container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: black;\n    color: white;\n    margin: auto;\n    margin-top: 30px;\n    width: 80%; /* Adjust width as needed */\n    max-width: 1600px; /* Ensure it doesn't exceed this width */\n    border-radius: 30px;\n    padding: 20px; /* Add padding for inner spacing */\n}\n\n.contact-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: black;\n    color: white;\n    margin: auto;\n    margin-top: 30px;\n    width: 80%; /* Adjust width as needed */\n    max-width: 1600px; /* Ensure it doesn't exceed this width */\n    border-radius: 30px;\n    padding: 20px; /* Add padding for inner spacing */\n    min-height:600px;\n\n}\n\n.inner-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    background-color: rgb(35, 35, 34);\n    padding:20px;\n    border-radius: 30px;\n}\n\nform {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n}\n\nlabel {\n    margin-bottom: 10px; /* Space between label and input */\n    font-size: 24px;\n}\n\ninput, textarea {\n    display: block;\n    border-radius: 5%;\n    width: 300px; /* Fixed width for inputs */\n    margin: 5px 0; /* Space between inputs */\n}\n\n.textbox {\n    width: 300px; /* Set a consistent width */\n}\n\n.input-help {\n    width: 100%; /* Full width of the container */\n    align-items: center;\n    display: flex;\n    justify-content: center;\n}\n\ntextarea {\n    width: 100%; /* Make textarea responsive */\n    max-width: 300px; /* Restrict maximum width */\n}\n\n.submit-button {\n    color: white;\n    background-color: rgb(0, 157, 255);\n    border: none; /* Remove default border */\n    font-family:'Courier New', Courier, monospace;\n    font-size:21px;\n    border-radius: 30%;\n    cursor: pointer; /* Change cursor on hover */\n    margin-top: 10px; /* Space above the button */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
